import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useToast } from '@/hooks/use-toast';

interface SettingsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function Settings({ open, setOpen }: SettingsProps) {
  const [googleApiKey, setGoogleApiKey] = useState('');
  const { toast } = useToast();

  useEffect(() => {
    // Carregar a API Key do Google do localStorage
    const savedGoogleApiKey = localStorage.getItem('googleApiKey') || '';
    setGoogleApiKey(savedGoogleApiKey);
  }, []);

  const handleSaveSettings = () => {
    // Salvar a API Key do Google no localStorage
    localStorage.setItem('googleApiKey', googleApiKey);
    
    // Fechar o modal
    setOpen(false);
    
    // Mostrar toast de confirmação
    toast({
      title: 'Configurações salvas',
      description: 'Suas configurações foram salvas com sucesso.',
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Configurações</DialogTitle>
          <DialogDescription>
            Configure a API do Google para a funcionalidade de busca.
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="googleApiKey" className="text-right">
              Google API Key
            </Label>
            <Input
              id="googleApiKey"
              type="password"
              value={googleApiKey}
              onChange={(e) => setGoogleApiKey(e.target.value)}
              className="col-span-3"
              placeholder="Insira sua chave de API do Google"
            />
          </div>
          
          <div className="col-span-4">
            <p className="text-sm text-muted-foreground mt-2">
              Esta chave é usada para a funcionalidade de busca integrada.
              Você pode obter uma chave no <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Google Cloud Console</a>.
            </p>
          </div>
        </div>
        
        <DialogFooter>
          <Button type="submit" onClick={handleSaveSettings}>
            Salvar alterações
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
} 